// extracted by mini-css-extract-plugin
export default {"secondary-nav":"styles_secondary-nav__YP9TF","active":"styles_active__3ewGd","nav-link-active":"styles_nav-link-active__V33-E"};